// extracted by mini-css-extract-plugin
export default {"container":"CountryWithFlag_container__zNSPL","flag":"CountryWithFlag_flag__9cz6+"};